<template>
  <!-- 13-2 教育机构收藏列表 -->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("collection") + $t("jobOffer") }}</div>
    <div class="main-box">
      <el-button type="primary" style="width: 100px" @click="deleteMore">{{
        $t("delete")
      }}</el-button>
      <!-- table部分 -->
      <div class="table">
        <el-table
          @row-click="qaq"
          :data="tableData"
          style="width: 98%"
          :max-height="tableHeight"
          v-loading="loading"
          @sort-change="changeTableSort"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- ----------------------案件番号---------------------- -->
          <el-table-column
            prop="number"
            label="案件番号"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="fuzzy"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.jobId }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------案件名---------------------- -->
          <el-table-column
            prop="name"
            label="案件名"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("caseName") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="fuzzy"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.jobName }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------医療機関---------------------- -->
          <el-table-column
            prop="medical"
            label="医療機関"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @input="fuzzy"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.medicalName }}</span>
            </template>
          </el-table-column>

          <!-- ----------------------勤務地---------------------- -->
          <el-table-column
            prop="workingPlace"
            label="勤務地"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("workLocation") }}</p>
              <el-input
                v-model="searchData4"
                size="mini"
                placeholder="Search"
                @input="fuzzy"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.workSpace }}</span>
            </template>
          </el-table-column>
          <!-- -----------------------掲載日----------------------- -->
          <el-table-column
            prop="publicationDate"
            label="掲載日"
            min-width="110"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("payonTheDay") }}</p>
              <el-date-picker
                v-model="searchData5"
                type="datetime"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd"
                clearable
                :placeholder="$t('registerDayselsect')"
              >
              </el-date-picker>
              <!-- <el-input
                v-model="searchData5"
                size="mini"
                placeholder="Search"
                @input="fuzzy"
                clearable
              /> -->
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.principalTime.split(" ")[0] }}</span>
            </template>
          </el-table-column>
          <!-- ------------------------担当者------------------------ -->
          <el-table-column prop="personCharge" label="担当者">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("inauguration") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @input="fuzzy"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.legalPerson }}</span>
            </template>
          </el-table-column>

          <!-- --------------------------観覧回数-------------------------- -->
          <el-table-column prop="numberVisits" label="観覧回数" sortable>
            <template slot="header">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
              <p></p>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.visitedTime }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------応募者-------------------------- -->
          <el-table-column prop="applicant" label="応募者" sortable>
            <template slot="header">
              <p class="operate">{{ $t("candidates") }}</p>
              <p></p>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.recruitNumber }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------状態-------------------------- -->
          <el-table-column prop="reviewStatus" label="状態" min-width="120">
            <template slot="header">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandStatus">
                <span class="el-dropdown-link">
                  {{ status }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in StatusData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'ja-JP'">{{
                scope.row.jpreviewStatus_dictText
              }}</span>
              <span v-else>{{ scope.row.reviewStatus_dictText }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="total"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import jwtDecode from "jwt-decode";
import AES from "../../js/AES";
import {
  selectJobCollect,
  fuzzySelectJobCollect,
  deleteJobCollect
} from "../../js/api";
import axios from "axios";
export default {
  name: "educationalInstionCaseCollectionList",
  components: {},
  data() {
    return {
      total: 0,
      inputData1: "", //搜索框input内容
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第五个搜索
      searchData6: "", //表格第六个搜索
      searchData7: "", //表格第七个搜索
      searchData8: "", //表格第八个搜索
      searchData9: "", //表格第九个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      multipleSelection: [],
      statusCode: "",
      StatusData: [],
      language: "",
      status: "All",
      principalTime: "",
      tableHeight: "" //表格高度
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.start();
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.getReviewStatus();
    this.getTableHeight();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    //挂载window.onresize事件(动态设置table高度)
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //获取表格高度
    getTableHeight() {
      let tableH = 320; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    timeJs(date) {
      //获取年份
      var y = date.getFullYear();
      //获取月份  返回0-11
      var m = date.getMonth() + 1;
      // 获取日
      var d = date.getDate();
      //获取星期几  返回0-6   (0=星期天)
      var w = date.getDay();
      //星期几
      var ww = " 星期" + "日一二三四五六".charAt(date.getDay());
      //时
      var h = date.getHours();
      //分
      var minute = date.getMinutes();
      //秒
      var s = date.getSeconds();
      //毫秒
      var sss = date.getMilliseconds();

      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }
      if (h < 10) {
        h = "0" + h;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (s < 10) {
        s = "0" + s;
      }
      if (sss < 10) {
        sss = "00" + sss;
      } else if (sss < 100) {
        sss = "0" + sss;
      }
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    dataTimeChange() {
      this.principalTime = this.timeJs(this.searchData5);
      this.fuzzy();
    },
    pickerChangeFn(value) {
      if (value === null) {
        this.principalTime = "";
        this.fuzzy();
      }
    },
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据3------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.getReviewStatus();
        that.start();
      }
    },
    //批量删除
    deleteMore() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择想要删除的用户",
          type: "warning"
        });
      } else {
        var jobListIdDTO = {
          listId: this.multipleSelection
        };
        deleteJobCollect(jobListIdDTO)
          .then(res => {
            if (res.data.code === "A0000") {
              console.log(jobListIdDTO);
              this.$message.success("批量删除成功");
              this.start();
            } else {
              this.$message.error("批量删除失败");
            }
          })
          .catch(res => {
            console.log("删除失败", res);
          });
      }
    },
    //模糊查询
    fuzzy() {
      var fuzzySelectJobCollectDTO = {
        reviewStatus: this.statusCode,
        jobId: this.searchData1,
        jobName: this.searchData2,
        legalPerson: this.searchData6,
        medicalName: this.searchData3,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        principalTime: this.principalTime,
        workSpace: this.searchData4
      };
      fuzzySelectJobCollect(fuzzySelectJobCollectDTO)
        .then(res => {
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.tableData = aesFecInfo.data;
            // this.$message.success("模糊查询成功")
            console.log("模糊查询", aesFecInfo);
          } else {
            this.$message.error("失败");
          }
        })
        .catch(res => {
          console.log("模糊查询失败", res);
        });
    },
    //跳转页面
    qaq(row, event, column) {
      this.$router.push({
        name: "educationViewJobInformation",
        query: { id: row.jobId }
      });
      console.log(row);
    },
    //查询案件
    start() {
      var pageDTO = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      selectJobCollect(pageDTO)
        .then(res => {
          if (res.data.code === "A0000") {
            // this.$message.success("查询成功");
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            this.total = aesFecInfo.total;
          } else {
            this.$message.error("查询失败");
          }
        })
        .catch(res => {
          console.log("查询失败", res);
        });
    },
    //筛选
    filterTag(value, row) {
      return row.tag === value;
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = [];
      for (var i = 0; i < val.length; i++) {
        this.multipleSelection.push(val[i].collectId);
      }
      console.log(this.multipleSelection);
    },
    handleCommand01(command) {
      if (command === "a") {
        console.log("选择了公開中");
      } else if (command === "b") {
        console.log("选择了未完成");
      }
    },
    //排序
    changeTableSort(column) {},
    //
    handleCurrentChange(elt) {
      this.currentPage = elt;
      this.start();
      console.log(this.currentPage);
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.start();
    },
    handleCommandStatus(evt) {
      this.statusCode = evt.code;
      this.status = evt.name;
      this.fuzzy();
    },
    // 管理员权限按钮
    handleIsShow() {},
    getReviewStatus() {
      var that = this;
      var dataItems = "";
      if (that.language === "ja-JP") {
        dataItems = "jpjobReviewStatus";
      } else {
        dataItems = "jobReviewStatus";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据reviewStatus--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.StatusData = aesFecInfo.data;
            console.log(that.StatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style>
.el-input__icon {
  display: none !important;
}
</style>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
}

.main-box {
  width: 100%;
  height: 80%;
  padding: 0 40px 0 40px;
  box-sizing: border-box;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  margin-top: 20px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}
.operate {
  height: 48px;
}
.table /deep/ .el-dropdown {
  width: 100px;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: 0;
  width: 67px;
}

.manager-application {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #fc630c;
  cursor: pointer;
}
.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.pagination-main {
  float: right;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #6b5656; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 4; /*行间距*/
}
.myButton-changlimit {
  background-color: #f56c6c;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Arial;
  font-size: 6px;
  padding: 6px 11px;
  text-decoration: none;
}

.myButton-changlimit2 {
  background-color: #409eff;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Arial;
  font-size: 6px;
  padding: 6px 11px;
  text-decoration: none;
}
</style>
<!-- j(){-->
<!--//   const code = jwtDecode(localStorage.getItem("token"));-->
<!--/   console.log(code);-->
<!--// },-->



// WEBPACK FOOTER //
// src/pages/educationalInstitutionCaseCollectionList/index.vue